import React from "react";
import { ButtonContainer } from "./button.styles";
import { ButtonProps, ButtonSize } from "./button.types";

const Button: React.FC<ButtonProps> = ({
  appearance,
  variant,
  size = ButtonSize.md,
  isFullWidth,
  disabled,
  children,
  ...rest
}) => {
  return (
    <ButtonContainer
      $appearance={appearance}
      $variant={variant}
      $size={size}
      $isFullWidth={isFullWidth}
      $disabled={disabled}
      disabled={disabled}
      {...rest}
    >
      {children}
    </ButtonContainer>
  );
};

export { Button };
